import colors from '../config/htmlNamedColors.json';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import '../styles/ColorSwatch.css';


/** CONFIGURATION */
const MESSAGE_UNSUPPORTED_COLOR =
    'Sample color does not show because it is not a supported HTML color name.';

const ColorSwatch = ({colorName, size, isActive = false, onClick = (e) => {}}) => {
    const buttonRef = useRef(null);

    const isColorSupported = () =>
        colors.find(
            (color) => color.name === colorName.toUpperCase()
        ) || colorName.toLowerCase() === 'transparent';

    const renderTooltip = (props) => <Tooltip
        {...props}>
        {colorName}{isColorSupported() ? '' : `: ${MESSAGE_UNSUPPORTED_COLOR}`}
    </Tooltip>;

    useEffect(() => {
        if (size && buttonRef.current) {
            buttonRef.current.style.height = size;
            buttonRef.current.style.width = size;
        }
    }, []);

    return <OverlayTrigger
        placement={'bottom'}
        delay={{ show: 100,
            hide: 100}}
        overlay={renderTooltip}
    >
        <button
            type={'button'}
            ref={buttonRef}
            className={`color-swatch${isActive ? ' active' : ''}`}
            onClick={onClick}
        >
            <svg
                viewBox={'0 0 100 100'}>
                <circle
                    cx={50}
                    cy={50}
                    r={50}
                    fill={isColorSupported() ? colorName : 'transparent'}
                />
            </svg>
        </button>
    </OverlayTrigger>;
};

ColorSwatch.propTypes = {
    colorName: PropTypes.string.isRequired,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    isActive: PropTypes.bool,
    onClick: PropTypes.func,
};

export default ColorSwatch;